import soilDataConfigApi from '@/api/config/soilDataConfigApi'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { Soil } from '@/types/soil'
import { QueryOptions, useQuery, UseQueryResult } from '@tanstack/react-query'

function useSearchSoil(
  searchParams: SearchParams = {},
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<Soil>, any> {
  return useQuery(
    [queryKeys.soil, interfaceId, searchParams],
    async () => {
      const { data } = await soilDataConfigApi.getAll({
        interfaceId,
        ...searchParams,
      })

      if (!data) return null

      return {
        list: data?.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchSoil
